import { getNonce } from '@thoughtspot/codec-util';
import { generateUUID } from '@thoughtspot/js-util';
import { assign } from '@thoughtspot/string-util';
import { isCustomBrandingEnabled } from '@thoughtspot/system-config-service';
import { CustomStylingConfig } from './custom-style-config';
let config = null;
const GET_STYLE_END_POINT = '/callosum/v1/file/getcustomstyle';
const CUSTOM_STYLE_NODE_ID = `custom-style-${generateUUID()}`;
const getCustomStyleNode = () => {
    let styleNode = document.querySelector(`#${CUSTOM_STYLE_NODE_ID}`);
    if (!styleNode) {
        styleNode = document.createElement('style');
        styleNode.setAttribute('id', CUSTOM_STYLE_NODE_ID);
        styleNode.setAttribute('nonce', getNonce());
        styleNode.setAttribute('type', 'text/css');
        document.head.appendChild(styleNode);
    }
    return styleNode;
};
const addCustomFontToSheet = (font) => {
    const styleNode = getCustomStyleNode();
    const styleSheet = styleNode.sheet;
    const fontFaceRule = font.toFontFaceRule();
    const fontFaceRuleText = assign(`@font-face {
            font-family: {fontFamily};
            src: url('{fontUrl}') format('{fontFormat}');
        }`, fontFaceRule);
    styleSheet.insertRule(fontFaceRuleText, styleSheet.cssRules.length);
};
const configChangeListeners = new Set();
export function setConfig(stylingConfig) {
    config = stylingConfig;
    configChangeListeners.forEach(listener => listener());
}
export function subscribeToConfigChange(listener) {
    configChangeListeners.add(listener);
    return () => {
        configChangeListeners.delete(listener);
    };
}
export function getDefaultConfig() {
    return CustomStylingConfig.fromJson({});
}
export function getConfig() {
    return config;
}
export function isColorRotationDisabled() {
    return config.isColorRotationDisabled();
}
export async function initCustomStylingService(styleConfig) {
    if (!isCustomBrandingEnabled()) {
        setConfig(CustomStylingConfig.fromJson({}));
    }
    else {
        setConfig(CustomStylingConfig.fromJson(styleConfig));
        (getConfig()?.getAllCustomFontFaces() || []).forEach((fontFace) => addCustomFontToSheet(fontFace));
    }
}
//# sourceMappingURL=custom-styling-service.js.map